import { ISchema, PaywallComponentProps } from '../@types'
import { mergeDeep } from '@/helpers/utils'
import simple_premium_12w_19_99_12w_79_usd from '@/data/products/subscription/prd_88fIPQK7k7jA'
import simple_premium_1w_5_19_4w_44_usd from '@/data/products/subscription/prd_Vva2wSaC1tuF'
import simple_premium_4w_9_99_4w_44_usd from '@/data/products/subscription/prd_uiSU5zmZM0eJ'

const extensionSchema: ISchema = {
	config: {
		background: 'primary',
		removeDiscountAfterCountdown: false,
		products: [
			{
				idents: {
					discounted: simple_premium_1w_5_19_4w_44_usd.ident,
					fallback: null,
				},
			},
			{
				idents: {
					discounted: simple_premium_4w_9_99_4w_44_usd.ident,
					fallback: null,
				},
			},
			{
				idents: {
					discounted: simple_premium_12w_19_99_12w_79_usd.ident,
					fallback: null,
				},
			},
		],
	},

	order: [
		'PaywallCountdownQuickAccess',
		'PaywallHead',
		'PaywallWeightPredict',
		[
			'PaywallTitle',
			({ $t }): PaywallComponentProps.Title => ({
				title: $t('pages.program.title_grab'),
			}),
		],
		[
			'PaywallCouponCountdown',
			(): PaywallComponentProps.CouponCountdown => ({
				discountPercent: 60,
			}),
		],
		'PaywallPlanPicker',
		'PaywallUserResearchBadge',
		[
			'PaywallButton',
			({ $t }): PaywallComponentProps.Button => ({
				text: $t('common.controls.get_my_plan'),
				type: 'GET_MY_PLAN_PLANPICKER',
				blockViewTitle: 'ONBOARDING_PAYWALL_PRODUCT_SELECTION_1_BLOCK',
				clickEvent: 'openBillingModal',
			}),
		],
		'PaywallPriceDisclaimer',
		'PaywallRatings',
		'PaywallDietsVsFasting',
		[
			'PaywallButton',
			({ $t, ctx }): PaywallComponentProps.Button => ({
				text: $t('pages.program.buttons.grab_my_plan_to_hit', {
					weight: ctx.localizedUserTargetWeight,
				}),
				type: 'GET_MY_PLAN_HIGHLIGHTS',
				clickEvent: 'openBillingModal',
			}),
		],
		'PaywallCustomerReviews',
		[
			'PaywallTitle',
			({ $t }): PaywallComponentProps.Title => ({
				title: $t('prepaywall.crm.visible_result.title'),
				customStyles: {
					marginLeft: '20px',
					marginRight: '20px',
				},
			}),
		],
		'PaywallCountdown',
		'PaywallPlanPicker',
		'PaywallUserResearchBadge',
		[
			'PaywallButton',
			({ $t }): PaywallComponentProps.Button => ({
				text: $t('common.controls.get_my_plan'),
				type: 'GET_MY_PLAN_PLANPICKER',
				blockViewTitle: 'ONBOARDING_PAYWALL_PRODUCT_SELECTION_2_BLOCK',
				clickEvent: 'openBillingModal',
			}),
		],
		'PaywallPriceDisclaimer',
		'PaywallFooterWithMoneyback',
		'PaywallBillingModal',
	],

	components: {
		PaywallCountdown: (): PaywallComponentProps.Countdown => ({
			text: `Your discount ends in {time} min`,
			theme: 'clock-purple',
		}),
		PaywallDietsVsFasting: ({ $t, ctx, $te }): PaywallComponentProps.DietsVsFasting => {
			const motivationEvent = ctx.answerMotivationEvent[0]
			let title = $t('pages.program.diets_vs_fasting.title')
			if (motivationEvent && $te(`pages.program.diets_vs_fasting.${motivationEvent}`)) {
				title = $t(`pages.program.diets_vs_fasting.${motivationEvent}`)
			}
			return {
				title: title,
				sex: 'female',
				countdownText: $t('pages.program.diets_vs_fasting.countdown_text', { percent: ctx.discountPercent }),
			}
		},
	},
}

export default (schema: ISchema): ISchema => mergeDeep({ ...schema }, extensionSchema)
